module.exports = __webpack_public_path__ + "img/icon_check_purple.2872ca7f.svg";